import { BARREL_SCOPE } from '@cli-constants/snapshots.js'
import { loadAllManifests } from './load-all-manifests.js'
import { loadManifest } from './load-manifest.js'

export function getAllTrackedFilePaths(cwd: string): string[] {
  const paths = new Set<string>()

  for (const { manifest } of loadAllManifests(cwd)) {
    for (const file of manifest.files) {
      paths.add(file.path)
    }
  }

  const barrelManifest = loadManifest(cwd, BARREL_SCOPE)
  if (barrelManifest) {
    for (const file of barrelManifest.files) {
      paths.add(file.path)
    }
  }

  return Array.from(paths).sort()
}
